import { sentryErrorTrackerWithScope } from "../tracking/sentry";

import { isSiError } from "./types";

const trackError = (error: Error): void => {
    const tags: Record<string, string> = {};

    if (isSiError(error)) {
        tags.errorCategory = error.context.category;

        if (error.context.component) {
            tags.errorSource = error.context.component;
        }

        if (error.context.operation) {
            tags.errorOperation = error.context.operation;
        }
    }

    sentryErrorTrackerWithScope({ errorMessage: error.message, e: error, tags });
};

export { trackError };
